export default "__VITE_ASSET__cd108573__"